import { AbgSxProps } from '@abg/typings';

export const optionStyle: AbgSxProps = (theme) => ({
  margin: '0 8px',
  borderRadius: `${theme.borderRadius.mediumCard}px`,

  '&:hover, &:focus, &:active, &.Mui-focused': {
    backgroundColor: `${theme.palette.background.tertiary} !important`,
    [theme.breakpoints.down('md')]: {
      backgroundColor: 'unset !important',
    },
  },
});
